/* Creed Fashion: velikosti na izbiri variante vedno po vrstnem redu
   (38, 39, 40 ... / S, M, L, XL, XXL, 3XL / 90 cm, 95 cm ...).
   Shopify vrstni red velikosti izpelje iz vrstnega reda variant po barvah,
   zato so pri izdelkih, kjer ena barva nima vseh številk, velikosti pomešane. */
(function () {
  'use strict';
  var L = { XXS: 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, '2XL': 6, '3XL': 7, XXXL: 7, '4XL': 8, '5XL': 9 };
  function key(v) {
    var s = String(v || '').trim().toUpperCase();
    if (s in L) return [1, L[s]];
    var m = s.match(/^(\d+(?:[.,]\d+)?)(\s*CM)?$/);
    if (m) return [0, parseFloat(m[1].replace(',', '.'))];
    return null;
  }
  function valOf(li) {
    var i = li.querySelector('input[data-option-value]');
    if (i) return i.getAttribute('data-option-value');
    var o = li.querySelector('.option_value');
    return o ? o.textContent : '';
  }
  function sortList(ul) {
    var items = Array.prototype.filter.call(ul.children, function (c) { return c.tagName === 'LI'; });
    if (items.length < 2) return;
    var ks = items.map(function (li) { return key(valOf(li)); });
    if (ks.some(function (k) { return k === null; })) return;
    var idx = items.map(function (li, n) { return n; });
    idx.sort(function (a, b) { var x = ks[a], y = ks[b]; return (x[0] - y[0]) || (x[1] - y[1]) || (a - b); });
    var sorted = true;
    for (var n = 0; n < idx.length; n++) { if (idx[n] !== n) { sorted = false; break; } }
    if (sorted) return;
    idx.forEach(function (n) { ul.appendChild(items[n]); });
  }
  function run() {
    document.querySelectorAll('ul.swatch-text, .product-variants-option ul').forEach(sortList);
    document.querySelectorAll('select.variant-options, .product-variants-option select').forEach(function (sel) {
      var opts = Array.prototype.slice.call(sel.options);
      var ks = opts.map(function (o) { return key(o.value); });
      if (opts.length < 2 || ks.some(function (k) { return k === null; })) return;
      var chosen = sel.value;
      opts.map(function (o, n) { return n; })
        .sort(function (a, b) { return (ks[a][0] - ks[b][0]) || (ks[a][1] - ks[b][1]) || (a - b); })
        .forEach(function (n) { sel.appendChild(opts[n]); });
      sel.value = chosen;
    });
  }
  var t = null;
  function schedule() { if (t) clearTimeout(t); t = setTimeout(run, 30); }
  function boot() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
